/** A static screenshot is acceptable only while the underlying capture is demonstrably live. */
export function healthyStaticCapture(video: HTMLVideoElement): boolean {
  const stream = video.srcObject
  if (!stream || !('getVideoTracks' in stream)) return false
  const tracks = (stream as MediaStream).getVideoTracks()
  return !video.paused && !video.ended && video.readyState >= 2 && tracks.some(track => track.readyState === 'live' && track.enabled && !track.muted)
}

/** Timed, live, multi-anchor samples may confirm even when animation changes pixels. */
export function canConfirmStaticLayout(sampledAt: number, previousSampleAt: number, video: HTMLVideoElement, anchors: number): boolean {
  return sampledAt - previousSampleAt >= 500 && healthyStaticCapture(video) && anchors >= 2
}

export function calibrationDelay(ms: number, signal: AbortSignal): Promise<void> {
  return new Promise(resolve => {
    const done = () => { clearTimeout(timer); signal.removeEventListener('abort', done); resolve() }
    const timer = setTimeout(done, ms)
    if (signal.aborted) done()
    else signal.addEventListener('abort', done, { once: true })
  })
}
